var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendImageGenerate = function SvgSendImageGenerate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.427 8.096-17-8A.999.999 0 0 0 .03 1.243L1.97 9.001.03 16.759a.998.998 0 0 0 1.397 1.147l17-8a1 1 0 0 0 0-1.81M2.482 15.198l.839-3.357L9 9.001l-5.68-2.84-.84-3.357 13.17 6.197z"
  })));
};
export default SvgSendImageGenerate;